<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1 style="padding-bottom:10px;">Acknowledgement</h1>
<p style="text-indent:0em;">To all my friends and family, who provided encouragement and support while I was writing this book. Thank you for helping me to write sensibly, sensitively and above all, truthfully about some delicate, personal subjects. In making this book complete, these stories need to be told.</p><br/>
<p style="text-indent:0em;">To the team at Austin Macauley, my publisher in London. Thank you for believing in this book and for coping with the time difference between London and Sydney; I realise I am asleep for most of your working day!</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?2acd659b